import styled from "@emotion/styled";


export const LectureBlockContainer = styled.div<{selected?:boolean, disabled?:boolean}>`
    width:100%;
    display:grid;
    grid-template-columns:1fr 1fr;
    border-radius: 5px;
    border: 1px solid ${props => props.theme.colors.placeholderColor};
    padding:6px 10px;
    font-size: 14px;
    background: ${props => props.disabled?"#EBEBEB":props.selected?props.theme.colors.placeholderColor:"#fff"};
    cursor: ${props => props.disabled?"not-allowed":"pointer"};
    transition: all 0.15s ease-in-out;

    span{
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        color: ${props => props.selected?"#fff":"#000"};
        transition: all 0.15s ease-in-out;
    }
    b{
        color: ${props => props.selected?"#fff":props.theme.colors.placeholderColor};
        transition: all 0.15s ease-in-out;
        font-weight: 400;
    }

    span:nth-of-type(even){
        text-align: right;
    }

    :hover{
        box-shadow: 0 0 4px 0 ${props => props.theme.colors.blue_50};
    }
`;
